import * as i0 from "@angular/core";
import * as i1 from "../http-helpers/http.wrapper";
/**
 ****************************************************************
 * Proxy class for getting logger configuration from server.
 *
 * Written by: Stanislav Korobov
 ****************************************************************
 */
var LogProxy = /** @class */ (function () {
    function LogProxy(httpWrapper) {
        this.httpWrapper = httpWrapper;
    }
    LogProxy.prototype.getLogConfig = function () {
        return this.httpWrapper.get("PatientPortalLog", "GetLoggerAnonimous", null, null);
    };
    LogProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LogProxy_Factory() { return new LogProxy(i0.ɵɵinject(i1.HttpWrapper)); }, token: LogProxy, providedIn: "root" });
    return LogProxy;
}());
export { LogProxy };
